import Clickoutside from './clickoutside';
import Mask from './mask';

export default {
  clickoutside: Clickoutside,
  mask: Mask,
};
